export default __webpack_public_path__ + "static/media/docker.62e35beb.svg";